/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useQuery } from '@tanstack/react-query';
import { getAccountStatus } from './account.api';

export const ACCOUNT_STATUS_KEY = 'accountStatus';

export function useGetAccountStatusQuery() {
    return useQuery({
        queryKey: [ACCOUNT_STATUS_KEY],
        queryFn: async ({ signal }) => getAccountStatus({ signal }),
        staleTime: 5 * 60 * 1000, // 5 minutes
        refetchOnWindowFocus: false,
        retry: false,
    });
}
